import { IconButton } from "./Button";

/** A fixed-length period (a week, a month) with previous and next arrows;
 * the forward arrow stops at the current period. */
export function PeriodStepper({
  unit,
  label,
  current,
  onShift,
}: {
  unit: "week" | "month";
  label: string;
  current: boolean;
  onShift: (by: -1 | 1) => void;
}) {
  return (
    <div
      className="ds-period"
      role="group"
      aria-label={unit === "week" ? "Week" : "Month"}
    >
      <IconButton
        icon="chevron-left"
        label={`Previous ${unit}`}
        size="sm"
        onClick={() => onShift(-1)}
      />
      <span className="ds-period-label">
        {label}
        {current ? " · so far" : ""}
      </span>
      <IconButton
        icon="chevron-right"
        label={`Next ${unit}`}
        size="sm"
        disabled={current}
        onClick={() => onShift(1)}
      />
    </div>
  );
}
